import Styled from 'styled-components'
import { styled } from '@mui/material/styles'
import Slider from '@mui/material/Slider'
import { Container } from 'react-bootstrap'
export const Img = Styled.img`


height: 100px;
margin-top: 20px;

`

export const Label = Styled.h1`
`
export const Space = Styled.div`
`
export const PrettoSlider = styled(Slider)({
  color: '#0b3275',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none'
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit'
    },
    '&:before': {
      display: 'none'
    }
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#0b3275',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)'
    },
    '& > *': {
      transform: 'rotate(45deg)'
    }
  }
})

export const TitleProduct = Styled.p`
 
`

export const Content = Styled.div`
`
export const ContainerStyled = styled(Container)({
  background: '#FFFFFF',
  borderRadius: '16px',
  overflow: 'initial'
})

export const Title = Styled.p`
  color: ${props => props.theme.primary};
`

export const SliderValues = Styled.div`
  display:flex;
  justify-content: center;
  gap: 1vh;
  color: #000000;
`

export const SmallTitle = Styled.p`
  font-style: normal;
  font-weight: 400;
  line-height: 145%;
  color: #767F8D;
`
export const ContainerCupom = Styled.div`
  display:flex;
  justify-content: space-between;
  gap: 2vh;
  .btn-gray {
    background: rgba(118, 127, 141, 0.1);
    color: #303742 !important;
    font-weight: 600;
    font-size: 15px;
    line-height: 120%;
  }
`

export const TitleBrand = Styled.p`
`

export const Box = Styled.div`
  background: #F0F0F0;
  position: relative;

  .slider {
    padding: 40px 50px;
  }
`

export const Line = Styled.div`
margin-top: 20px;
margin-bottom: 20px;
border: solid 1px #F0F2F5;
`

export const Block = Styled.div`
position: relative;
display: flex;
flex-direction: column;
margin: auto;
background: #F0F0F0;
.slider-filter {
  .bol-left,
  .bol-right {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      position: absolute;
      top: 33%;
      background: #FFFFFF;
      box-shadow: 4px 10px 21px rgba(0, 0, 0, 0.16);
      border: 2px solid ${props => props.theme.primary};
      z-index: 5;
  }
  .bol-left {
      left: 35px;
  }
  .bol-left::after {
      content: "Pontos";
      position: absolute;
      top: -20px;
      left: -10px;
      font-size: 12px;
      color: ${props => props.theme.primary};
  }
  .bol-right {
      right:35px;
  }
  .bol-right::after {
      content: "Valor";
      position: absolute;
      top: -20px;
      right: -5px;
      font-size: 12px;
      color: ${props => props.theme.primary};
  }
}
@media (max-width: 280px) {
  .slider-filter {
    .bol-left,
    .bol-right {
      top: 26%;
    }
  }
}
`